import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useMemo } from 'react';
import useLocalStorage from '../../hooks/useLocalStorage';

const names = {
  S7: 'player1',
  S8: 'player2',
  S9: 'player3',
  S10: 'player4',
  S11: 'moreNoise',
};

const playerStates = ['S7', 'S8', 'S9', 'S10', 'S11'];

export const Player = ({ currentState }) => {
  const [playerNumber, setPlayerNumber] = useLocalStorage('player', 'player1');

  useEffect(() => {
    if (!Object.values(names).includes(playerNumber)) {
      setPlayerNumber('player1');
    }
  }, []);

  useEffect(() => {
    if (!currentState || !playerStates.includes(currentState)) {
      return;
    }

    setPlayerNumber(names[currentState]);
  }, [currentState]);

  const srcVideoPlayer = useMemo(() => {
    const protocol = window?.location.protocol || 'https:';
    return `${protocol}//stream-test.iactive.pro/rotor-sk/videos/${playerNumber}.webm`;
  }, [playerNumber]);

  return (
    <AnimatePresence>
      <motion.div
        key={srcVideoPlayer}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        style={{ width: '100%', height: '100%' }}
      >
        <video autoPlay="autoplay" muted="muted" loop id="bgVideo1">
          <source src={srcVideoPlayer} type="video/webm" />
        </video>
      </motion.div>
    </AnimatePresence>
  );
};
